import { ShoppingBagIcon as PhosphorShoppingBagIcon, type IconProps } from "@phosphor-icons/react";

export function ShoppingBagIcon(props: IconProps): React.ReactElement {
  return <PhosphorShoppingBagIcon size={24} weight="regular" {...props} />;
}
